const DEFAULT_CONFIDENCE_PERCENT_DIGITS = 1;
const MAX_TO_FIXED_DIGITS = 20;

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

function normalizeDigits(digits: number | undefined): number {
  if (typeof digits !== 'number' || !Number.isFinite(digits)) {
    return DEFAULT_CONFIDENCE_PERCENT_DIGITS;
  }

  return clamp(Math.trunc(digits), 0, MAX_TO_FIXED_DIGITS);
}

function hasDisplayableScore(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

export function normalizeConfidenceScore(value: unknown): number {
  if (!hasDisplayableScore(value)) {
    return 0;
  }

  const normalized = value > 1 ? value / 100 : value;
  return clamp(normalized, 0, 1);
}

export function confidencePercent(value: unknown): number {
  return normalizeConfidenceScore(value) * 100;
}

export function formatConfidencePercent(value: unknown, digits?: number): string {
  return `${confidencePercent(value).toFixed(normalizeDigits(digits))}%`;
}

export function formatConfidenceLabelWithScore(
  label?: string | null,
  score?: unknown,
): string {
  const trimmedLabel = typeof label === 'string' ? label.trim() : '';
  const hasScore = hasDisplayableScore(score);

  if (trimmedLabel && hasScore) {
    return `${trimmedLabel} (${formatConfidencePercent(score)})`;
  }

  if (trimmedLabel) {
    return trimmedLabel;
  }

  if (hasScore) {
    return formatConfidencePercent(score);
  }

  return '';
}
